import React from "react";
import styled from "styled-components";

interface Props {
  label: string;
  value: string | number;
  sub?: string;
  accent?: boolean;
  accentHealthy?: boolean;
  accentSilent?: boolean;
}

const KPICard: React.FC<Props> = ({ label, value, sub, accent, accentHealthy, accentSilent }) => (
  <Card $accent={accent} $accentHealthy={accentHealthy} $accentSilent={accentSilent}>
    <Label>{label}</Label>
    <Value>{value}</Value>
    {sub && <Sub>{sub}</Sub>}
  </Card>
);

export default KPICard;

const Card = styled.div<{ 
  $accent?: boolean;
  $accentHealthy?: boolean;
  $accentSilent?: boolean;
}>`
  background: #fff;
  border-radius: 8px;
  padding: 18px 22px;
  min-width: 130px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  border-left: 4px solid ${({
    $accent,
    $accentHealthy,
    $accentSilent,
  }) => (
    $accent ? "#FE5912" : $accentHealthy ? "#2e7d32" : $accentSilent ? "#c62828" : "#0058A9"
  )};
`;

const Label = styled.p`
  font-size: 11px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 6px;
`;

const Value = styled.p`
  font-size: 26px;
  font-weight: 700;
  color: #222;
  margin: 0;
  line-height: 1;
`;

const Sub = styled.p`
  font-size: 11px;
  color: #aaa;
  margin: 4px 0 0;
`;
